import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import { useCreationModal } from './CreateUserGroupModal';
import UserGroupList from './UserGroupList';

const UserGroupListPage = () => {
    const { t } = useTranslation(['userGroupList']);

    const creationModal = useCreationModal();
    const { permissions: accountPermissions } = useAccount();
    const company = useCompany(true);

    const hasPermission = company
        ? hasPermissions(company.permissions, [permissionKind.createUserGroup]) &&
          hasPermissions(accountPermissions, [permissionKind.createUserGroup])
        : hasPermissions(accountPermissions, [permissionKind.createUserGroup]);

    const extra = (
        <>
            {creationModal.render()}
            {hasPermission && (
                <Button icon={<PlusOutlined />} onClick={creationModal.open} type="primary">
                    {t('userGroupList:actions.addUserGroup')}
                </Button>
            )}
        </>
    );

    return (
        <ConsolePageWithHeader extra={extra} title={t('userGroupList:title')}>
            <UserGroupList />
        </ConsolePageWithHeader>
    );
};

export default UserGroupListPage;
